import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { PostEditorFormFields } from "../formShapes";
import { DatePicker } from "../../../../../../components";
import TimePicker from "rc-time-picker";
import PostMediaAttachments from "../PostMediaAttachments";
import AddPhotoVideoAttachment from "../AddPhotoVideoAttachment";
import {FORM_MODE} from "../../../../socialConstants";

const dateFormat = "YYYY-MM-DDTHH:mm:ss";

const initialOfferPost = {
  eventTitle: "",
  eventStart: moment().startOf("day").format(dateFormat),
  eventEnd: moment().startOf("day").add(1, "days").format(dateFormat)
}


const OfferPost = (props) => {
  const { values, onChangeSetObject, mode } = props;
  const googlePost = values.googlePost ? values.googlePost : initialOfferPost;

  const eventStart = moment(googlePost.eventStart, dateFormat);
  const eventEnd = moment(googlePost.eventEnd, dateFormat);
  const eventStartHasZeroHours = eventStart.format(dateFormat).endsWith("00:00:00");
  const eventEndHasZeroHours = eventEnd.format(dateFormat).endsWith("00:00:00");
  const [addTime, setAddTime] = useState(!eventStartHasZeroHours || !eventEndHasZeroHours);

  useEffect(() => {
    if (!values.googlePost) onChangeSetObject({ googlePost: initialOfferPost });
  }, []);

  /** STYLES **/
  const containerStyle = "d-flex flex-column justify-content-between chatter-publish-textarea-container";
  /** END STYLES **/

  /** HELPER FUNCTIONS **/
  const toggleAddTime = () => {
    if (addTime) {
      setAddTime(false);
    } else {
      setAddTime(true);
      onChangeSetObject({
        googlePost: {
          ...googlePost,
          eventStart: eventStart.startOf("day").format(dateFormat),
          eventEnd: eventEnd.startOf("day").format(dateFormat)
        }
      });
    }
  };
  const onOfferDetailsChange = (e) => onChangeSetObject({googlePost: {...googlePost, summary: e.target.value}});
  const onOfferCouponChange = (e) => onChangeSetObject({googlePost: {...googlePost, offerCouponCode: e.target.value}});
  const onOfferLinkChange = (e) => onChangeSetObject({googlePost: {...googlePost, offerRedeemOnlineUrl: e.target.value}});
  const onOfferTermsChange = (e) => onChangeSetObject({googlePost: {...googlePost, offerTermsConditions: e.target.value}});
  const onOfferTitleChange = (e) => {
    onChangeSetObject({googlePost: {...googlePost, eventTitle: e.target.value}});
    // Also copy the text into the text field so that it shows up in the Publishing Calendar when you click it.
    // This is a workaround since Google Local Posts may not be permanent and we don't have designs for the Post Details view.
    onChangeSetObject({text: e.target.value});
  }
  const renderStartTimePicker = () => {
    if (!addTime) return undefined;
    return (
      <TimePicker
        className="block mt-2"
        value={eventStart}
        onChange={(moment) => onChangeSetObject({googlePost: {...googlePost, eventStart: moment.format(dateFormat)}})}
        allowEmpty={false}
        use12Hours={true}
        showSecond={false}
        disabled={mode === FORM_MODE.VIEW}
      />
    );
  }
  const renderEndTimePicker = () => {
    if (!addTime) return undefined;
    return (
      <TimePicker
        className="block mt-2"
        value={eventEnd}
        onChange={(moment) => onChangeSetObject({googlePost: {...googlePost, eventEnd: moment.format(dateFormat)}})}
        allowEmpty={false}
        use12Hours={true}
        showSecond={false}
        disabled={mode === FORM_MODE.VIEW}
      />
    );
  }

  const renderInput = (placeholder, value, onChange) => {
    if (mode === FORM_MODE.VIEW) return undefined;
    return (
      <input
        className="form-control mt-3"
        type="text"
        placeholder={placeholder}
        value={value || ""}
        onChange={onChange}
        disabled={mode === FORM_MODE.VIEW}
      />
    );
  }
  /** END HELPER FUNCTIONS **/

  return (
    <div className={containerStyle} >
      <div className="d-flex mt-2 mb-2">
        <div className="input-group block">
          <input
            className="form-control"
            placeholder={"Offer Title"}
            type="text"
            value={googlePost.eventTitle || ""}
            onChange={onOfferTitleChange}
            disabled={mode === FORM_MODE.VIEW}
          />
          <label className="font-weight-lighter m-1">(Example: 20% off in store or online)</label>
        </div>
      </div>
      <div className="d-flex">
        <div className="block flex-1 mr-2">
          <label>Start Date</label>
          <DatePicker
            date={eventStart.toDate() || moment().toDate()}
            onChange={(day) => onChangeSetObject({ googlePost: {...googlePost, eventStart: moment(day).startOf("day").format(dateFormat)} })}
            disabledDays={(day) => moment(day).isBefore(moment().startOf("day"))}
            disabled={mode === FORM_MODE.VIEW}
          />
          { renderStartTimePicker() }
        </div>
        <div className="block flex-1 mr-2">
          <label>End Date</label>
          <DatePicker
            date={eventEnd.toDate() || moment().toDate()}
            onChange={(day) => onChangeSetObject({ googlePost: {...googlePost, eventEnd: moment(day).startOf("day").format(dateFormat)} })}
            disabledDays={(day) => moment(day).isBefore(moment().startOf("day"))}
            disabled={mode === FORM_MODE.VIEW}
          />
          { renderEndTimePicker() }
        </div>
        <div className="block flex-1">
          <input type="checkbox" id="addTime" checked={addTime} onChange={toggleAddTime} disabled={mode === FORM_MODE.VIEW} />
          <label htmlFor="addTime" className="pl-2"> Add Time</label>
        </div>
      </div>
      <div className="d-flex">
        <div className="input-group block">
          { renderInput("Offer details", googlePost.summary, onOfferDetailsChange) }
          { renderInput("Coupon code (optional)", googlePost.offerCouponCode, onOfferCouponChange) }
          { renderInput("Link to redeem offer (optional)", googlePost.offerRedeemOnlineUrl, onOfferLinkChange) }
          { renderInput("Terms and conditions (optional)", googlePost.offerTermsConditions, onOfferTermsChange) }
        </div>
      </div>
      <div className="d-flex flex-column justify-content-between mt-2">
        { mode === FORM_MODE.EDIT && (
          <div className="d-flex flex-row">
            <AddPhotoVideoAttachment {...props} />
          </div>
          )
        }
        <div className="d-flex flex-row">
          <PostMediaAttachments {...props}/>
        </div>
      </div>
    </div>
  );
}

OfferPost.propTypes = PostEditorFormFields;

export default OfferPost;
